module.exports = __webpack_public_path__ + "static/media/10S.d78a1dfe.svg";